import React from "react";
import PropTypes from "prop-types";
import { Stack, Box, Typography, Button, Modal, Fade } from "@mui/material";
import { Close } from "@mui/icons-material";

const PhoneDirectoryModal = ({ openModal, handleCloseModal, phoneDirectory }) => {
    return (
        <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
            <Fade in={openModal}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 400,
                        bgcolor: "white",
                        boxShadow: 24,
                        p: "20px 32px",
                        borderRadius: 2
                    }}
                >
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontSize: { xs: "medium", lg: "x-large" } }}>
                            Phone Directory
                        </Typography>
                        <Button onClick={handleCloseModal} sx={{ minWidth: "auto", padding: 0 }}>
                            <Close />
                        </Button>
                    </Stack>
                    <Box mt={2}>
                        {phoneDirectory &&
                            Object.entries(phoneDirectory).map(([name, number]) => (
                                <Typography key={name} variant="body1" sx={{ marginBottom: 1 }}>
                                    <strong>{name}: </strong>
                                    <a
                                        href={`tel:${number}`}
                                        style={{ textDecoration: "none", color: "inherit" }}
                                    >
                                        {number}
                                    </a>
                                </Typography>
                            ))}
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

PhoneDirectoryModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    phoneDirectory: PropTypes.object.isRequired
};

export default PhoneDirectoryModal;
